import { useQuery } from '@tanstack/react-query';
import { useField } from 'formik';
import { TextField } from 'src/components/TextField';
import { fetchWorkoutPlanOptions } from 'src/models/workout-plan/workout-plan';

interface WorkoutPlanSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

interface FormWorkoutPlanSelectProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

export const WorkoutPlanSelect: React.FC<WorkoutPlanSelectProps> = ({
  value,
  onChange,
  label = 'Workout Plan',
  placeholder = 'Select Workout Plan',
  disabled = false,
  error,
  helperText,
}) => {
  const { data: workoutPlans, isLoading } = useQuery({
    queryKey: ['workoutPlans'],
    queryFn: fetchWorkoutPlanOptions,
    staleTime: 60000,
    gcTime: 60000,
  });

  const options = [
    { value: '', label: placeholder, disabled: true },
    ...(workoutPlans || []).map((plan) => ({
      value: plan.id,
      label: plan.name,
    })),
  ];

  return (
    <TextField
      label={label}
      error={error}
      helperText={helperText}
      disabled={isLoading || disabled}
      options={options}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export const FormWorkoutPlanSelect: React.FC<FormWorkoutPlanSelectProps> = ({
  name,
  label,
  placeholder,
  disabled,
  onChange,
}) => {
  const [field, meta] = useField({ name });

  return (
    <WorkoutPlanSelect
      value={field.value || ''}
      onChange={(value) =>
        onChange ? onChange(value) : field.onChange({ target: { name, value } })
      }
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched ? meta.error : undefined}
    />
  );
};
